import CanalCobroUpdate from './CanalCobroUpdate'
export {CanalCobroUpdate}
export default CanalCobroUpdate
